import { valueCurrencyShortcut } from 'helpers/priceHelpers';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

interface OwnProps {
  totalCost: number;
  currencyId: string;
}

const TotalCostBlock = (props: OwnProps) => {
  const { totalCost, currencyId } = props;

  const { t } = useCustomTranslation();

  return (
    <div className="TotalCost">
      <span className="label">{t('customData.totalCost')}</span>
      <span className="value">{valueCurrencyShortcut(totalCost, currencyId, t)}</span>
    </div>
  );
};

export default TotalCostBlock;
